<template>
  <div>
    <b-container fluid>
      <h1>トラフィック計算</h1>
      <b-row align-h="start">
        <template >
          <button type="button" class="btn btn-outline-secondary button_spacer" @click="startTrafficCalculate">計算スタート</button>
        </template>
        <button
          @click="displayResumeModal = !displayResumeModal"
          class="btn btn-outline-secondary"
        >戻る</button>
      </b-row>
      <br>
      <br>
      <h1>トラフィック計算結果</h1>
      <b-row align-h="start">
        <template >
          <button type="button" class="btn btn-outline-secondary button_spacer" @click="displayResult">表示</button>
        </template>
        <button
          @click="downloadsCSV"
          class="btn btn-outline-secondary"
        >DL</button>
      </b-row>
      <b-container v-for="(item, index) in items" :key="index">
        <h5>[ システムNo.{{ index + 1 || 1 }} ]</h5>
        <b-form-group
          label="A 制御通信"
          label-cols="3"
          label-for="traffic_a"
          label-align="left"
          required
        >
          <b-form-input
            id="traffic_a"
            v-model="items[index].traffic_a"
            disabled
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="MA 通信"
          label-cols="3"
          label-for="traffic_ma"
          label-align="left"
          required
        >
          <b-form-input
            id="traffic_ma"
            v-model="items[index].traffic_ma"
            disabled
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="IT 通信"
          label-cols="3"
          label-for="traffic_it"
          label-align="left"
          required
        >
          <b-form-input
            id="traffic_it"
            v-model="items[index].traffic_it"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-container>
      <b-modal
        v-model="cannotDesign"
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
      >
        <b-row align-h="center">
          <p>{{ errorMessage }}</p>
        </b-row>
        <b-row align-h="center">
          <button
            class="btn btn-outline-secondary"
            @click="pageBack"
          >OK</button>
        </b-row>
      </b-modal>
      <b-modal
        v-model="displayResumeModal"
        hide-footer
      >
        <b-row align-h="around">
          <p>移動してよろしいですか？？</p>
        </b-row>
        <b-row align-h="around">
          <router-link
            class="btn btn-outline-secondary"
            to="/"
          >はい</router-link>
          <button
            class="btn btn-outline-secondary"
            @click="displayResumeModal = !displayResumeModal"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
import { mapState } from 'vuex'
export default {
  name: 'Traffic',
  data () {
    return {
      displayResumeModal: false,
      items: [
        {
          traffic_a: 0,
          traffic_ma: 0,
          traffic_it: 0
        }
      ],
      fields: [],
      cannotDesign: false,
      errorMessage: ''
    }
  },
  methods: {
    async startTrafficCalculate () {
      try {
        const result = await API.graphql(graphqlOperation(`
          mutation createTrafficCalculatorDesign {
            createTrafficCalculator (
              version: "${this.version}"
              job_id: "${this.job_id}"
            ) {
              job_id
              version
            }
          }
        `))
        this.$store.commit('updateJobId', result.data.createCommandDesign.job_id)
        this.makeToast('成功', 'トラフィック計算のジョブを起動しました。しばらくしたら表示を押下してください。', 'info')
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', '予期せぬエラーが発生しました', 'danger')
      }
    },
    async displayResult () {
      const result = await API.graphql(graphqlOperation(`
        query listMaxTraffic{
          listMaxTraffic(job_id:"${this.job_id}"){
            items{
              traffic_a
              traffic_ma
              traffic_it
            }
          }
        }
      `))
      if (result.data.listMaxTraffic.items.length === 0) {
        this.makeToast('失敗', 'トラフィック計算の結果の取得に失敗しました', 'danger')
        return
      }
      this.items = result.data.listMaxTraffic.items
      this.makeToast('成功', 'トラフィック計算の結果を取得しました', 'info')
    },
    async downloadsCSV () {
      const target = this.items
      let csv = '\ufeff' + 'system_cofing_no,a,ma,it\n'
      target.forEach(function (elm, index) {
        csv += `${index + 1},`
        csv += elm['traffic_a'] + ','
        csv += elm['traffic_ma'] + ','
        csv += elm['traffic_it'] + '\n'
      })
      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, 'TrafficCalculate.csv')
      } else {
        link.href = window.URL.createObjectURL(blob)
        link.download = 'TrafficCalculate.csv'
        link.click()
        this.all_loading = false
      }
    },
    async getLatestDesign () {
      const response = await API.graphql(graphqlOperation(`
        query getLatestDesign{
          getLatestDesign(version: "${this.version}"){
            job_id
            version
            status
            property_design{
              items {
                id
              }
            }
            attribute_design {
              items {
                id
              }
            }
            command_design {
              items{
                id
              }
            }
            command_by_protocol {
              items{
                id
              }
            }
            command_by_sender {
              items {
                id
              }
            }
          }
        }
      `))
      this.$log.debug(response)
      return response
    },
    async listSystemConfig () {
      const tempSystemConfigData = await API.graphql(graphqlOperation(`
        query listSystemConfig {
          listSystemConfig {
            items {
              config
            }
          }
        }
      `))
      return tempSystemConfigData
    },
    async listGroupConfig () {
      const tempGroupConfigData = await API.graphql(graphqlOperation(`
        query listGroupConfig {
          listGroupConfig {
            items {
              config
            }
          }
        }
      `))
      return tempGroupConfigData
    },
    async getTrafficConfig () {
      const registeredData = await API.graphql(graphqlOperation(`
        query getTrafficConfig {
          getTrafficCalculatorConfig {
            config
          }
        }
      `))
      return registeredData
    },
    pageBack () {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState(['version', 'job_id', 'completed_job'])
  },
  async created () {
    const latestDesign = await this.getLatestDesign()
    if (latestDesign.data.getLatestDesign.command_design.items.length === 0) {
      this.errorMessage = 'コマンド設計終了後に再度実行してください'
      this.cannotDesign = true
    }
    const systemConfig = await this.listSystemConfig()
    if (systemConfig.data.listSystemConfig.items.length === 0) {
      this.errorMessage = 'システム構成が登録されていません'
      this.cannotDesign = true
    }
    const groupConfig = await this.listGroupConfig()
    if (groupConfig.data.listGroupConfig.items.length === 0) {
      this.errorMessage = 'グループ構成が登録されていません'
      this.cannotDesign = true
    }
    const trafficConfig = await this.getTrafficConfig()
    if (trafficConfig.data.getTrafficCalculatorConfig.config === '') {
      this.errorMessage = 'トラフィック計算設定が登録されていません'
      this.cannotDesign = true
    }
  }
}
</script>
<style>
</style>
